export default __webpack_public_path__ + "static/media/questionmark.dd0b3804.svg";